import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { panelHeading } from "../../styles";

type LeagueMode = "TARGET" | "FINAL_POSITIONS" | "GAMEWEEK_CHALLENGE" | "SCORE_PREDICTOR" | "SYNDICATE";

interface Props {
  mode: LeagueMode;
  actionLink: string | null;
  onViewRules: () => void;
  onInviteFriends: () => void;
}

const ACCENT = "var(--color-warning)";

const stepNumber: React.CSSProperties = {
  flexShrink: 0, width: 28, height: 28, borderRadius: "50%",
  display: "flex", alignItems: "center", justifyContent: "center",
  fontSize: "0.85rem", fontWeight: 700,
  background: ACCENT, color: "rgba(0, 0, 0, 0.8)",
};

const stepText: React.CSSProperties = {
  fontSize: "0.9rem", color: "var(--color-text)", lineHeight: 1.5,
};

const linkBtn: React.CSSProperties = {
  background: "none", border: "none", padding: 0, font: "inherit",
  color: "var(--color-text)", fontWeight: 600, cursor: "pointer",
};

function Step({ n, children }: { n: number; children: React.ReactNode }) {
  return (
    <div style={{ display: "flex", gap: "0.85rem" }}>
      <span style={stepNumber}>{n}</span>
      <div style={stepText}>{children}</div>
    </div>
  );
}

export default function HowItWorksPanel({ mode, actionLink, onViewRules, onInviteFriends }: Props) {
  const { t } = useTranslation();
  const step3Description = t(`league.howItWorks.step3.${mode}.description`);
  const step3Cta = t(`league.howItWorks.step3.${mode}.cta`);

  return (
    <div style={{
      background: `color-mix(in srgb, ${ACCENT} 20%, var(--color-bg))`,
      borderRadius: 16, padding: "1.5rem 1.75rem",
    }}>
      <h2 style={panelHeading}>
        {t("league.howItWorks.title")}
      </h2>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.1rem" }}>
        <Step n={1}>
          {t("league.howItWorks.step1")} <button onClick={onViewRules} style={{ ...linkBtn, textDecoration: "underline" }}>{t("league.howItWorks.viewRules")}</button>
        </Step>
        <Step n={2}>
          {t("league.howItWorks.step2")} <button onClick={onInviteFriends} style={{ ...linkBtn, textDecoration: "underline" }}>{t("league.howItWorks.inviteFriends")}</button>
        </Step>
        <Step n={3}>
          {step3Description}
          {step3Cta && actionLink && <> <Link to={actionLink} style={{ color: "var(--color-text)", fontWeight: 600, textDecoration: "underline" }}>{step3Cta} →</Link></>}
        </Step>
        <Step n={4}>
          {t(`league.howItWorks.step4.${mode}`)}
        </Step>
      </div>
    </div>
  );
}
